/* cs-forms.js (CS v29, 23 Oct 2026, audit LEAD-09; CS v32 adds the thank-you scroll below)
   The quote form on /pages/contact-us lives in the page content in three languages.
   Its "Enquiry type" and "Message" fields were required even when the buyer had already
   picked a product, a quantity and a country. This makes both optional; the form's own
   script still fills the routing (triage when no type is chosen) and appends the enquiry
   details to the message, so the email the team receives is never empty.
   If this file fails to load, the form keeps working as before (fields stay required). */
(function () {
  function ready(fn) { if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }
  ready(function () {
    ['cs-eq-intent', 'cs-eq-message'].forEach(function (id) {
      var el = document.getElementById(id);
      if (!el) return;
      el.removeAttribute('required');
      el.setAttribute('aria-required', 'false');
      var label = document.querySelector('label[for="' + id + '"]');
      if (label) label.classList.add('cs-eq-optional');
    });
  });

  /* CS v32 (23 Oct 2026, audit LEAD-04). After a form is sent, Shopify returns to ?contact_posted=true#contact_form.
     The page's own script shows the thank-you message and scrolls to it as soon as the page is parsed, but the browser
     then jumps to #contact_form, which leaves the message above the screen (450 px above it in the 23 Oct test).
     This brings the message back into view once the page has loaded and moves focus to it, so screen readers read it.
     It only scrolls and focuses: the page's script still shows the message and sends the analytics events. */
  function showSent() {
    var ok = document.getElementById('cs-eq-success');
    if (!ok || ok.hidden) return false;
    if (!ok.hasAttribute('tabindex')) ok.setAttribute('tabindex', '-1');
    ok.scrollIntoView({ block: 'center' });
    try { ok.focus({ preventScroll: true }); } catch (e) { ok.focus(); }
    return true;
  }
  window.csShowEnquirySent = showSent; /* lets a check call it on the normal contact page */
  if (/[?&]contact_posted=true/.test(window.location.search)) {
    var run = function () { window.requestAnimationFrame(function () { setTimeout(showSent, 60); }); };
    if (document.readyState === 'complete') run(); else window.addEventListener('load', run);
  }
})();
